export default __webpack_public_path__ + "static/media/mir.42300851.svg";